import { render, staticRenderFns } from "./light.vue?vue&type=template&id=4d8926cc&scoped=true"
import script from "./light.vue?vue&type=script&lang=js"
export * from "./light.vue?vue&type=script&lang=js"
import style0 from "./light.vue?vue&type=style&index=0&id=4d8926cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8926cc",
  null
  
)

export default component.exports